var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#181818","fillRule":"nonzero"},[React.createElement("path",{"d":"M9 0C4.037 0 0 4.037 0 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9zm0 16.364c-4.06 0-7.364-3.304-7.364-7.364C1.636 4.94 4.94 1.636 9 1.636c4.06 0 7.364 3.304 7.364 7.364 0 4.06-3.304 7.364-7.364 7.364z","key":0}),React.createElement("path",{"d":"M9 3.818a1.092 1.092 0 1 0 1.09 1.091c0-.601-.488-1.09-1.09-1.09zM9 7.636a.818.818 0 0 0-.818.819v4.909a.818.818 0 0 0 1.636 0v-4.91A.818.818 0 0 0 9 7.637z","key":1})]));
}

Info.defaultProps = {"width":"18","height":"18"};

module.exports = Info;

Info.default = Info;
